<script setup>
defineProps({
  variant: {
    type: String,
    default: "primary",
    validator: (value) => {
      return ["primary", "secondary"].includes(value);
    },
  }
})

</script>

<template>
  <button class="btn" :class="`btn-${variant}`">
    <slot></slot>
  </button>
</template>

<style scoped>
.btn {
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.btn-primary {
  background-color: #350755;
  color: #fff;
}

.btn-primary:hover {
  background-color: #4c0f8a;
}

.btn-secondary {
  background-color: #e2e8f0;
  color: #1a202c;
}

.btn-secondary:hover {
  background-color: #cbd5e0;
}
</style>